import '../../vendor/clickmenu.js';

export const setupMenu = () => {
  const menuToggle = document.getElementById('slideout-toggle') as HTMLButtonElement;
  const menuToggleClose = document.getElementById('slideout-toggle-close') as HTMLButtonElement;
  const menuWrapper = document.querySelector('.nav-wrapper') as HTMLElement;
  const menuPageBody = document.querySelector('body') as HTMLElement;

  if (menuToggle != null) {
    menuToggle.addEventListener('click', function () {
      if (menuWrapper.classList.contains('active')) {
        menuWrapper.classList.remove('active');
        menuPageBody.classList.remove('menu-active');
      } else {
        menuWrapper.classList.add('active');
        menuPageBody.classList.add('menu-active');
      }
    });
  }

  if (menuToggleClose != null) {
    menuToggleClose.addEventListener('click', function () {
      if (menuWrapper.classList.contains('active')) {
        menuWrapper.classList.remove('active');
        menuPageBody.classList.remove('menu-active');
      }
    });
  }

  $('.main-nav').clickMenu();
};
